module.exports = __webpack_public_path__ + "static/media/extranet.0cbb57c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/extranet.svg
// module id = 2190
// module chunks = 0